export enum SnCameraUnmanagedType {
  JPEG = 'JPEG',
  HLS = 'HLS',
  RTMP = 'RTMP',
  SLDP = 'SLDP',
}
